var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "app-main-inner search",
          attrs: {
            visible: _vm.innerVisible,
            title: _vm.$t("SeaExport.QueryLCLJobOrder2"),
            width: "1085px",
            "append-to-body": "",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            }
          }
        },
        [
          _vm.isFba
            ? _c(
                "div",
                { staticClass: "app-main-inner-row" },
                [
                  _c("search-item", {
                    attrs: {
                      "config-module": "10013",
                      reset: true,
                      "show-simple": false,
                      "expand-adv": true,
                      "col-settings": { span: 8 },
                      "custom-search-items": _vm.customSearchItems
                    },
                    on: { advSearchItemCallBack: _vm.toQueryForFba }
                  })
                ],
                1
              )
            : _vm._e(),
          !_vm.isFba
            ? _c(
                "div",
                { staticClass: "app-main-inner-row" },
                [
                  _c("search-item", {
                    ref: "searchItem",
                    attrs: {
                      "config-module": "402",
                      reset: true,
                      "show-simple": false,
                      "expand-adv": true,
                      "custom-search-items": _vm.customSearchItems,
                      "col-settings": { span: 8 },
                      "grid-config-module": "402001"
                    },
                    on: {
                      advSearchItemCallBack: _vm.toAdvancedQuery,
                      perConfigChange: function(value) {
                        _vm.perConfigName = value
                      },
                      refreshGrid: function() {
                        _vm.gridRefreshId += 1
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "app-main-inner-row row-grid",
              staticStyle: { "min-height": "350px", padding: "0" }
            },
            [
              _c("cargo-ag-grid", {
                staticStyle: { height: "300px" },
                attrs: {
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData,
                  "per-config-name": _vm.perConfigName,
                  "refresh-id": _vm.gridRefreshId,
                  "config-module": "402001"
                },
                on: {
                  gridReady: function(params) {
                    _vm.gridApi = params.api
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "app-main-inner-row row-pagination-right" },
            [
              _c("cargo-pagination", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.searchConditions.total > 0,
                    expression: "searchConditions.total>0"
                  }
                ],
                attrs: {
                  "config-module": "150003",
                  total: _vm.searchConditions.total,
                  page: _vm.searchConditions.pageNum,
                  limit: _vm.searchConditions.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.searchConditions, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.searchConditions, "pageSize", $event)
                  },
                  pagination: _vm.fetchDataByPage
                }
              })
            ],
            1
          ),
          _vm.isFba
            ? _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "space-between"
                  },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c("span", [
                    _c("b", [
                      _vm._v(
                        _vm._s(_vm.$t("SeaExport.QuantityOfSelectedOrder")) +
                          "：" +
                          _vm._s(_vm.selectedRows.length)
                      )
                    ])
                  ]),
                  _c(
                    "div",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", no: "1" },
                          on: { click: _vm.add }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Add3")))]
                      ),
                      _c(
                        "el-button",
                        { attrs: { no: "2" }, on: { click: _vm.closeHandler } },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
                      )
                    ],
                    1
                  )
                ]
              )
            : _vm._e(),
          !_vm.isFba
            ? _c(
                "span",
                {
                  staticClass: "min-h",
                  staticStyle: { padding: "10px" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "div",
                    { staticStyle: { float: "right" } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", no: "3" },
                          on: { click: _vm.add }
                        },
                        [_vm._v(_vm._s(_vm.$t("SeaExport.Add3")))]
                      ),
                      _c(
                        "el-button",
                        { attrs: { no: "4" }, on: { click: _vm.closeHandler } },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
                      )
                    ],
                    1
                  )
                ]
              )
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }